import {baseTenToSixteen} from "../converters/math";
import {RGBTuple} from "../types/colors";
import {XYZArray} from "../types/math";


export type Cube = RGBTuple[][][]
type Row = RGBTuple[][]
type Column = RGBTuple[]

export type viewSettings = "global"|"local"


//  rename how steps works outside this function
//  make adjustable steps
// make allow for centering
// todo decide if a edge number should make an uneven cube
export default function HexCube(width:number=8, stepi:number=32, centering?:XYZArray|boolean):Cube{
    console.log(`draw cube - width:${width}, steps:${stepi}, center:${centering}`)
    let cube: Cube = []
    let start, end: XYZArray;
    let step: number;

    if(!!!centering || !(typeof centering === "object")){
        // global
        console.log("first")
        start = [0,0,0]
        step = stepi
        end = [width*step, width*step, width*step]
    }else{
        // centering
        console.log("second")
        step = stepi
        start = [centering[0]-step*width/2, centering[1]-step*width/2, centering[2]-step*width/2]

        if(start[0]<0){start[0]=0}
        if(start[1]<0){start[1]=0}
        if(start[2]<0){start[2]=0}

        end = [width*step + start[0] , width*step + start[1] ,width*step + start[2] ]
    }


    for (let x = start[0]; x < end[0]; x += step) {
        if( x>256 ){
            continue
        }
        let row: Row = []
        for (let y = start[1]; y < end[1]; y += step) {
            if( y>256 ){
                continue
            }
            let column: Column = []
            for (let z = start[2]; z < end[2]; z += step) {
                if( z>256 ){
                    continue
                }
                // console.log("xyz",x,y,z)
                column.push(`(${baseTenToSixteen(x)},${baseTenToSixteen(y)},${baseTenToSixteen(z)})`)
            }
            row.push(column)
        }
        cube.push(row)
    }
    // console.log(cube)
    return cube


}